import type { Pass, SignInVisitorRequest } from '@sine/sine-core-api-types';

export enum SineHeader {
  X_SINE_TEAM_ID = 'x-sine-team-id',
  X_SINE_DEVICE_ID = 'x-sine-device-id',
  X_SINE_VERSION = 'x-sine-version',
  AUTHORIZATION = 'Authorization',
  RQUID = 'rquid',
}

export type PrePass = Partial<SignInVisitorRequest & Pick<Pass, 'visitorTypeDetails' | 'host' | 'startDate'>> & {
  status: 'pre-pass';
};

export const PassEventDataNameWorkflow = {
  WORKFLOW_INTEGRATION_REJECTED: 'workflowIntegrationRejected',
  WORKFLOW_INTEGRATION_ACCEPTED: 'workflowIntegrationAccepted',
};

export enum DisabledWorkflowReasonCode {
  WORKFLOW_OR_FEATURE_DISABLED = 'WORKFLOW_OR_FEATURE_DISABLED',
}

export enum RejectedWorkflowReasonCode {
  RESPONSE_PENDING = 'RESPONSE_PENDING',
  RESPONSE_REJECTED = 'RESPONSE_REJECTED',
  RESPONSE_MISSING = 'RESPONSE_MISSING',
  RESPONSE_INVALIDATED = 'RESPONSE_INVALIDATED',
  RESPONSE_EXPIRED = 'RESPONSE_EXPIRED',
  RESPONSE_COMPANY_INVALID = 'RESPONSE_COMPANY_INVALID',
  RESPONSE_INVITED = 'RESPONSE_INVITED',
}

export type WorkflowReasonCode = RejectedWorkflowReasonCode | DisabledWorkflowReasonCode;

export enum WorkflowCheckResult {
  APPROVED = 'Approved',
  PENDING = 'Pending',
  REQUIRED = 'Required',
}

/** The text displayed to visitors */
export const workflowRejectionReasonText = {
  [RejectedWorkflowReasonCode.RESPONSE_COMPANY_INVALID]: WorkflowCheckResult.PENDING,
  [RejectedWorkflowReasonCode.RESPONSE_PENDING]: WorkflowCheckResult.PENDING,
  [RejectedWorkflowReasonCode.RESPONSE_REJECTED]: WorkflowCheckResult.REQUIRED,
  [RejectedWorkflowReasonCode.RESPONSE_MISSING]: WorkflowCheckResult.REQUIRED,
  [RejectedWorkflowReasonCode.RESPONSE_INVALIDATED]: WorkflowCheckResult.REQUIRED,
  [RejectedWorkflowReasonCode.RESPONSE_EXPIRED]: WorkflowCheckResult.REQUIRED,
  [RejectedWorkflowReasonCode.RESPONSE_INVITED]: WorkflowCheckResult.REQUIRED,
};

export enum RunWorkflowIntegrationResultActionCode {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  PERMIT_REQUIRED = 'PERMIT_REQUIRED',
}

export enum WorkflowIntegrationStatusCode {
  SUCCESS = 'SUCCESS',
  REJECTED = 'REJECTED',
  DISABLED = 'DISABLED',
}

export interface WorkflowEntityLine {
  code: WorkflowIntegrationStatusCode;
  actionCode?: RunWorkflowIntegrationResultActionCode;
  reasonCode?: WorkflowReasonCode;
  company?: {
    id?: string;
    name: string;
  };
  version?: number;
  workflow: {
    name: string;
    id: string;
    token: string;
    link: string;
    type?: string;
    logo?: string;
    response?: {
      id: string;
      state: string;
      expiryDate?: Date;
    };
  };
}
